import { FormArray, FormControl, FormGroup } from '@angular/forms';

export interface IIshikawaTemplateBone {
  id: number;
  name: string;
  isDefault: boolean;
  icon: string;
  color: string;
  order: number;
}

export interface IIshikawaTemplate {
  id: number;
  name: string;
  isDefault: boolean;
  bones?: IIshikawaTemplateBone[];
}

/** A bone as the API takes it; the array order is the bone order. Bones without an id are created. */
export interface IIshikawaTemplateBoneRequest {
  id?: number;
  name: string;
  icon: string;
  color: string;
}

export interface IIshikawaTemplateRequest {
  name: string;
  bones: IIshikawaTemplateBoneRequest[];
}

export interface IEditIshikawaTemplate {
  dto: IIshikawaTemplateRequest;
  id: number;
}

/** Bone as shown in the list: default bone names are already translated. */
export interface IIshikawaTemplateBoneView {
  id: number;
  name: string;
  icon: string;
  color: string;
}

export interface IIshikawaTemplateRow {
  id: number;
  name: string;
  isDefault: boolean;
  bones: IIshikawaTemplateBoneView[];
}

export enum EIshikawaTemplateDialogMode {
  add = 'add',
  edit = 'edit',
  view = 'view',
}

export interface IIshikawaTemplateDialogData {
  mode: EIshikawaTemplateDialogMode;
  /** Edited template; null when adding. */
  id: number | null;
  name: string;
  bones: IIshikawaTemplateBoneRequest[];
}

export type TIshikawaTemplateBoneForm = FormGroup<{
  id: FormControl<number | null>;
  name: FormControl<string>;
  icon: FormControl<string>;
  color: FormControl<string>;
}>;

export type TIshikawaTemplateForm = FormGroup<{
  name: FormControl<string>;
  bones: FormArray<TIshikawaTemplateBoneForm>;
}>;
